module.exports = __webpack_public_path__ + "static/caymus-1cf0c641f6bf2de362e6cf97b3afbfbf.jpg";